// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title":"title_FuVkp","content":"content_xjO4T","list":"list_XLc+-"};